import React from 'react';
import { Typography, Box, Alert } from '@mui/material';
import { TransactionForm } from '../components/forms';
import { TRANSACTION_TYPES } from '../constants';

export default function Refund() {
  return (
    <Box>
      <Typography variant="h4" sx={{ pl: 3, pt: 2, mb: 1 }}>
        Refund
      </Typography>
      <Alert severity="warning" variant="filled" sx={{ mx: 3, mb: 2, fontWeight: 'bold' }}>
        You are on the REFUND page — this issues a credit to a cash customer, not a sale.
      </Alert>
      <TransactionForm type={TRANSACTION_TYPES.REFUND} />
    </Box>
  );
}